import { GridColDef } from "@mui/x-data-grid";
import SystemChatDetailButton from "./DetailButton";

export const systemChatColumns: GridColDef[] = [
  {
    field: "",
    renderCell: SystemChatDetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "isRead",
    minWidth: 150,
    headerName: "Okundu",
    type: "boolean",
    sortable: true,
    filterable: true,
  },
  {
    field: "isSystem",
    minWidth: 150,
    headerName: "Sistem",
    type: "boolean",
    sortable: true,
    filterable: true,
  },
  {
    field: "userId",
    headerName: "Kaullanıcı Id",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "fullName",
    headerName: "Ad Soyad",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "message",
    headerName: "Mesaj",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "creationTime",
    headerName: "Oluşturulma Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 180,
    valueGetter: (v, r) => new Date(v),
  },
];
